<app-inbound-form-wrapper
  data-testid="inbound-edit-form-wrapper"
  [inboundData]="inboundData()"
  [itemDetails]="itemDetails()"
  [viewMode]="false"
  [editMode]="true"
  [loading]="loading()"
  [saving]="saving()"
  [statusChangeConfirmed]="isStatusChangeConfirmed()"
  [statusAutoCorrected]="statusAutoCorrected()"
  [correctedStatus]="correctedStatus"
  (formAction)="onFormAction($event)"
  (statusChange)="onStatusChange($event)"
></app-inbound-form-wrapper>

<!-- Status Change Dialog -->
<app-status-change-dialog
  data-testid="inbound-edit-status-change-dialog"
  [visible]="showStatusDialog()"
  [data]="statusDialogData"
  (visibleChange)="onDialogVisibilityChange($event)"
  (result)="onStatusDialogResult($event)"
></app-status-change-dialog>

<!-- Toast messages -->
<p-toast data-testid="inbound-edit-toast"></p-toast>
